import * as React from 'react';
import { CustomerNotifications as TravelAdvidsory } from 'src/common/components/common/customer-notifications';
import { CustomerNotificationLocation } from '@shared-ui/customer-notifications';
export const SharedUiTravelAdvisory = () => React.createElement(TravelAdvidsory, {
  location: CustomerNotificationLocation.AFTER_WIZARD
});